import React from "react";
import { Link } from "react-router-dom";
import Routes from "../constants/routes.json";
import Language from "../utils/Language";
import styles from "./Footer.module.css";

function Footer(props) {
  const { changeLanguage } = props;
  const currentLang = Language.GetLangId() === 1 ? "en" : "de";

  return (
    <footer className={styles.Outer}>
      <div className={styles.Inner}>
        <div className={styles.Grid}>
          <div>
            <div className={styles.Brand}>
              <img
                className={styles.BrandLogo}
                alt="Uelstudios"
                src={require("../media/branding/uelstudios_logo.png")}
              />
            </div>
            <p className={styles.Tagline}>
              {Language.GetString("footer_tagline")}
            </p>
          </div>

          <div>
            <div className={styles.ColumnTitle}>
              {Language.GetString("footer_explore")}
            </div>
            <div className={styles.Links}>
              <Link to={Routes.home} className={styles.LinkRow}>
                {Language.GetString("nav_new")}
              </Link>
              <Link to={Routes.games} className={styles.LinkRow}>
                {Language.GetString("nav_games")}
              </Link>
              <Link to={Routes.dev} className={styles.LinkRow}>
                {Language.GetString("nav_dev")}
              </Link>
              <Link to={Routes.legal} className={styles.LinkRow}>
                {Language.GetString("footer_legal")}
              </Link>
            </div>
          </div>

          <div>
            <div className={styles.ColumnTitle}>
              {Language.GetString("footer_language")}
            </div>
            <div className={styles.LangSelect}>
              <button
                type="button"
                onClick={() => changeLanguage("de")}
                className={
                  currentLang === "de"
                    ? `${styles.LangButton} ${styles.LangButtonActive}`
                    : styles.LangButton
                }
              >
                Deutsch
              </button>
              <button
                type="button"
                onClick={() => changeLanguage("en")}
                className={
                  currentLang === "en"
                    ? `${styles.LangButton} ${styles.LangButtonActive}`
                    : styles.LangButton
                }
              >
                English
              </button>
            </div>
          </div>
        </div>

        <div className={styles.Bottom}>
          <span>{Language.GetString("footer_copyright")}</span>
          <Link to={Routes.legal}>{Language.GetString("footer_legal")}</Link>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
